import NewsletterForm from "./NewsletterForm";

const brandLinks = [
  { label: "Custom Creations", href: "#custom" },
  { label: "Events", href: "#story" },
  { label: "The Priolo Family", href: "#story" },
  { label: "Meet the Team", href: "#story" },
  { label: "Blog", href: "#story" },
];

const serviceLinks = [
  { label: "Contact Us", href: "#contact" },
  { label: "FAQs", href: "#story" },
  { label: "Shipping & Return Policy", href: "#story" },
  { label: "Terms & Conditions", href: "#story" },
  { label: "Privacy Policy", href: "#story" },
];

export default function Footer() {
  return (
    <footer id="contact" className="bg-foreground-900 text-background-100">
      <div className="w-full px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-10 lg:gap-12">
          <div>
            <h2 className="font-label text-xs tracking-[0.24em] uppercase text-background-50 mb-6">
              Sofia Jewelry
            </h2>
            <ul className="space-y-3">
              {brandLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="font-body text-sm text-background-100/75 hover:text-primary-300 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
            <div className="flex items-center gap-4 mt-7">
              <a
                href="https://www.facebook.com/sofiajewelry/"
                target="_blank"
                rel="noopener nofollow"
                aria-label="Facebook"
                className="w-9 h-9 flex items-center justify-center border border-background-100/25 rounded-full text-background-100/80 hover:text-primary-300 hover:border-primary-300 transition-colors"
              >
                <i className="ri-facebook-fill text-sm" />
              </a>
              <a
                href="https://www.instagram.com/sofiajewelry/"
                target="_blank"
                rel="noopener nofollow"
                aria-label="Instagram"
                className="w-9 h-9 flex items-center justify-center border border-background-100/25 rounded-full text-background-100/80 hover:text-primary-300 hover:border-primary-300 transition-colors"
              >
                <i className="ri-instagram-line text-sm" />
              </a>
            </div>
          </div>

          <div>
            <h2 className="font-label text-xs tracking-[0.24em] uppercase text-background-50 mb-6">
              Visit Us
            </h2>
            <ul className="space-y-4 font-body text-sm text-background-100/75">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-base text-primary-300 mt-0.5" />
                <a
                  href="https://www.google.com/maps/search/?api=1&query=80+Throckmorton+Ave+Mill+Valley+CA+94941-1918+United+States"
                  target="_blank"
                  rel="noopener nofollow"
                  className="hover:text-primary-300 transition-colors leading-relaxed"
                >
                  80 Throckmorton Ave
                  <br />
                  Mill Valley, CA 94941-1918
                  <br />
                  United States
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-phone-line text-base text-primary-300" />
                <a
                  href="tel:+18174808824"
                  className="hover:text-primary-300 transition-colors"
                >
                  (817) 480-8824
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-user-star-line text-base text-primary-300" />
                <span>Owner — Sophie Priolo</span>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="font-label text-xs tracking-[0.24em] uppercase text-background-50 mb-6">
              Customer Service
            </h2>
            <ul className="space-y-3">
              {serviceLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="font-body text-sm text-background-100/75 hover:text-primary-300 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="font-label text-xs tracking-[0.24em] uppercase text-background-50 mb-6">
              Newsletter
            </h2>
            <p className="font-body text-sm text-background-100/75 mb-5 leading-relaxed">
              Subscribe to receive updates, access to exclusive deals, and more.
            </p>
            <NewsletterForm />
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-background-100/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-body text-xs tracking-wide text-background-100/60">
            © SOFIA JEWELRY 2026. ALL RIGHTS RESERVED.
          </p>
          <p className="font-body text-xs tracking-wide text-background-100/60">
            80 THROCKMORTON AVE, MILL VALLEY, CA 94941
          </p>
        </div>
      </div>
    </footer>
  );
}